import Helper from '@app/helper';

const makeUser = (response) => {
  const {
    id,
    full_name,
    email,
    language,
    transfer_default_expiry,
    plan_tier,
  } = response;

  const user = {
    id,
    full_name,
    email,
    language,
    loggedIn: id,
    preferences: {
      transfer_default_expiry,
    },
    defaults: {
      profile_picture_thumbnail_url: Helper.getAvatar(id),
    },
    planTier: plan_tier,
  };

  if (response.memberships && response.memberships[0]) {
    user.memberships = response.memberships;
    user.storageFull = !!response.memberships[0].storage_full;
  }

  user.profile_picture = response.profile_picture || null;

  return user;
};

export default {
  /*
    This method parses the response from either sign_in endpoint
    or the value of bootstrapped window.__session__.user
  */
  auth(response) {
    let account = {};
    let subscription = {};

    const { memberships } = response;

    response.use_new_subscription_system = true; //This is a temporary step to allow backend to remove this property. It will be deleted from the JS after that.

    // Retrieve account from memberships & subscription id
    if (memberships && memberships.length > 0 && memberships[0].account) {
      account = memberships[0].account;
      account.use_new_subscription_system =
        response.use_new_subscription_system;
      subscription = account.subscription;
    }

    return {
      user: makeUser(response),
      subscription,
      account,
    };
  },

  /*
    This method parses the response of user endpoint
  */
  user: makeUser,

  account(response) {
    let emailBackground = null;
    // Email background?
    if (response.email_background) {
      emailBackground = response.email_background;
    }

    return {
      ...response,
      email_background: emailBackground,
    };
  },

  subscription(response) {
    return response;
  },
};
